import GpsCoordinates from './GpsCoordinates';
import { GpsAccuracy } from '@app/enumerations';

export default class GpsCoordinatesWithAccuracy extends GpsCoordinates {
	public gpsAccuracy: GpsAccuracy | null = null;

	public constructor() {
		super();
	}
};